interface ExtensionVersion {
  parts: bigint[];
  prerelease: string[] | null;
}

function parseVersion(value: string | null): ExtensionVersion | null {
  if (!value) return null;
  const match = /^(\d+(?:\.\d+){0,3})(?:-([\dA-Za-z-]+(?:\.[\dA-Za-z-]+)*))?(?:\+[\dA-Za-z-]+(?:\.[\dA-Za-z-]+)*)?$/.exec(value.trim());
  if (!match) return null;
  const prerelease = match[2]?.split(".") ?? null;
  if (prerelease?.some((part) => /^0\d+$/.test(part))) return null;
  return { parts: match[1]!.split(".").map((part) => BigInt(part)), prerelease };
}

export function isExtensionOutdated(installed: string | null, current: string | null): boolean {
  const a = parseVersion(installed);
  const b = parseVersion(current);
  if (!a || !b) return false;
  for (let i = 0; i < Math.max(a.parts.length, b.parts.length); i++) {
    const installedPart = a.parts[i] ?? 0n;
    const currentPart = b.parts[i] ?? 0n;
    if (installedPart !== currentPart) return installedPart < currentPart;
  }
  if (!a.prerelease) return false;
  if (!b.prerelease) return true;
  for (let i = 0; i < Math.max(a.prerelease.length, b.prerelease.length); i++) {
    const installedPart = a.prerelease[i];
    const currentPart = b.prerelease[i];
    if (installedPart === currentPart) continue;
    if (installedPart === undefined) return true;
    if (currentPart === undefined) return false;
    const installedNumeric = /^\d+$/.test(installedPart);
    const currentNumeric = /^\d+$/.test(currentPart);
    if (installedNumeric && currentNumeric) return BigInt(installedPart) < BigInt(currentPart);
    if (installedNumeric !== currentNumeric) return installedNumeric;
    return installedPart < currentPart;
  }
  return false;
}
